import { createFileRoute } from '@tanstack/react-router';
import { DealEditorPage } from '@/features/deals';

export const Route = createFileRoute('/_authed/deals/new')({
  component: DealsCreateRouteComponent,
});

function DealsCreateRouteComponent() {
  return <DealEditorPage mode="create" />;
}
